import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900 text-foreground-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-400"></i>
              </div>
              <span className="font-heading text-xl font-bold">{t('site.name')}</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed">{t('site.description')}</p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-foreground-200">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">{t('nav.home')}</Link>
              <Link to="/category/all" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">{t('nav.category')}</Link>
              <Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 whitespace-nowrap">{t('nav.about')}</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold mb-4 text-foreground-200">热门分类</h4>
            <div className="flex flex-wrap gap-2">
              {[
                { slug: 'romance', name: '恋爱' },
                { slug: 'fantasy', name: '奇幻' },
                { slug: 'action', name: '动作' },
                { slug: 'school', name: '校园' },
                { slug: 'mystery', name: '悬疑' },
                { slug: 'drama', name: '剧情' },
              ].map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-1 bg-background-800 hover:bg-primary-500/80 rounded-full text-xs text-foreground-300 hover:text-foreground-50 transition-all duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">{t('footer.copyright')}</p>
          <p className="text-foreground-500 text-xs">{t('footer.disclaimer')}</p>
        </div>
      </div>
    </footer>
  );
}